import React, { useState } from "react";
import { Link, useNavigate,useLocation } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import loginRight from "../assets/img/login-right.png";
import packageJson from '../../package.json';

const BASE_URL = packageJson.apiUrl;
const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    city: "",
    country: "",
    userType: "individual", // Default selection
    termsAccepted: false,
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    // Clear individual field error when user types
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setSuccess("");

  // Phone number validation (10 digits only)
 if (!/^\d{10}$/.test(formData.phone)) {
  setErrors((prev) => ({
    ...prev,
    phone: "Phone number must be exactly 10 digits and contain only numbers.",
  }));
  return;
}

    // Basic client-side validation
    if (!formData.termsAccepted) {
      setErrors((prev) => ({
        ...prev,
        termsAccepted: "You must accept the Terms and Conditions.",
      }));
      return;
    }
	if (formData.password.length < 8) {
      setErrors((prev) => ({
        ...prev,
        password: "Password must be at least 8 characters long.",
      }));
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        confirmPassword: "Passwords do not match.",
      }));
      return;
    }

    // API call
    try {
      const response = await fetch(`${BASE_URL}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          password: formData.password,
          password_confirmation: formData.confirmPassword, // Laravel expects `password_confirmation`
          city: formData.city,
          country: formData.country,
          role: formData.userType, // Laravel expects `role` instead of `userType`
		  company_name: formData.userType === "company" ? formData.companyName : null,
          termsAccepted: formData.termsAccepted ? 1 : 0,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.errors) {
          setErrors(errorData.errors);
        } else {
          throw new Error(errorData.message || "Registration failed.");
        }
        return;
      }

      const data = await response.json();
	  
      localStorage.setItem("token", data.token);
	  localStorage.setItem("user", JSON.stringify(data.user)); 
	 // const redirectTo = location.state?.from || "/";
	 const redirectTo = localStorage.getItem("redirectAfterLogin") || location.state?.from || "/";
    localStorage.removeItem("redirectAfterLogin");
      navigate(redirectTo);
    //  navigate("/dashboard");
	  // Force page reload after navigation
    window.location.reload();
      setSuccess("Registration successful! Please log in.");
      setFormData({
        name: "",
        phone: "",
        email: "",
        password: "",
        confirmPassword: "",
        city: "",
        country: "",
        userType: "individual",
        termsAccepted: false,
      });
	 
   //  navigate("/login");
    } catch (err) {
      setErrors((prev) => ({ ...prev, apiError: err.message }));
    }
  };

  return (
    <div>
      <BreadCrumb />
      <section className="login-page section-space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="login-box">
                <div className="row g-0">
                  <div className="col-lg-7">
                    <div className="login-left">
                      <h2 className="login-title">Register</h2>
                      <p className="d-p">
                        Already have an account? <Link to="/login">Login</Link>
                      </p>
                      {errors.apiError && <p style={{ color: "red" }}>{errors.apiError}</p>}
                               {success && (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {success}
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      )}
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label className="label-top">Name</label>
                          <input
                            className="form-control"
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter Full Name"
                            required
                          />
                          {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}
                        </div>
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="label-top">Phone</label>
                              <input
                                className="form-control"
                                type="tel"
								pattern="\d{10}" 
								maxlength="10" 
								title="Please enter a 10-digit mobile number"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="Enter Phone No."
                                required
                              />
                              {errors.phone && <p style={{ color: "red" }}>{errors.phone}</p>}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="label-top">Email</label>
                              <input
                                className="form-control"
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter Email ID"
                                required
                              />
                              {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="label-top">Password</label>
                              <input
                                className="form-control"
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Enter Password"
                                required
                              />
                              {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="label-top">Confirm Password</label>
                              <input
                                className="form-control"
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                placeholder="Re-enter Password"
                                required
                              />
                              {errors.confirmPassword && (
                                <p style={{ color: "red" }}>{errors.confirmPassword}</p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="label-top">City/Town</label>
                              <input
                                className="form-control"
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                placeholder="Enter City/Town Name"
                                required
                              />
                              {errors.city && <p style={{ color: "red" }}>{errors.city}</p>}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="label-top">Country</label>
                              <select
                                className="form-select form-control"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select Country</option>
                                <option value="United Kingdom of Great Britain and Northern Ireland">United Kingdom of Great Britain and Northern Ireland</option>
                              </select>
                              {errors.country && <p style={{ color: "red" }}>{errors.country}</p>}
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="userType"
                              value="individual"
                              checked={formData.userType === "individual"}
                              onChange={handleChange}
                            />
                            <label className="form-check-label">
                              Register for Individual
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="userType"
                              value="company"
                              checked={formData.userType === "company"}
                              onChange={handleChange}
                            />
                            <label className="form-check-label">
                              Register for Company
                            </label>
                          </div>
                        </div>
						{formData.userType === "company" && (
						  <div className="form-group">
							<label className="label-top">Company Name</label>
							<input
							  className="form-control"
							  type="text"
							  name="companyName"
							  value={formData.companyName}
							  onChange={handleChange}
							  placeholder="Enter Company Name"
							  required={formData.userType === "company"}
							/>
							{errors.companyName && <p style={{ color: "red" }}>{errors.companyName}</p>}
						  </div>
						)}

                        <div className="form-group">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="termsAccepted"
                              checked={formData.termsAccepted}
                              onChange={handleChange}
                            />
                            <label className="form-check-label label-link">
                              I accept the <a href="/terms" target="_blank" rel="noopener noreferrer">
  Terms and Conditions
</a> &amp;{" "}<a href="/privacy-policies" target="_blank" rel="noopener noreferrer">
 Privacy Policy
</a>.
                            </label>
                          </div>
                          {errors.termsAccepted && (
                            <p style={{ color: "red" }}>{errors.termsAccepted}</p>
                          )}
                        </div>
                        <div className="form-group text-center">
                          <button type="submit" className="btn btn-green">
                            Register
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="col-lg-5 d-flex">
                    <div className="login-right w-100 d-flex">
                      <img src={loginRight} className="img-fluid" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Register;
